//@flow
import type { DbStatesType } from "../../conference/types/UserFormType";
const initialState: DbStatesType = {
  enrolments: [],
  imgToken: undefined,
  detectedFaces: undefined,
  conference: undefined,
  user: undefined,
  searchResults: undefined,
  people: [],
  count: undefined,
  peopleFetchTime: undefined,
  updating: 0,
};

const databaseReducer = (
  state: DbStatesType = initialState,
  actions: Object
) => {
  switch (actions.type) {
    case "SET_CONFERENCEID":
      if (actions.conference !== undefined) {
        return {
          ...state,
          conference: actions.conference,
        };
      }
      return state;

    case "SET_USER":
      if (actions.user !== undefined) {
        return {
          ...state,
          user: actions.user,
        };
      }
      return state;

    case "UPDATE_USER":
      if (actions.field !== undefined && actions.value !== undefined) {
        let user = state.user;
        if (actions.field in user) {
          user[actions.field] = actions.value;
        } else {
          let additional_person_fields = user.additional_person_fields
            ? user.additional_person_fields
            : {};
          additional_person_fields[actions.field] = actions.value;
          user.additional_person_fields = additional_person_fields;
        }
        return {
          ...state,
          user: user,
        };
      }
      return state;

    case "SAVE_TOKEN":
      if (actions.token !== undefined) {
        return {
          ...state,
          imgToken: actions.token,
        };
      } else {
        return {
          ...state,
          ImgToken: undefined,
        };
      }

    case "DETECT_IMAGE":
      if (actions.detectedFaces !== undefined) {
        return {
          ...state,
          detectedFaces: actions.detectedFaces,
        };
      } else {
        return {
          ...state,
          detectedFaces: undefined,
        };
      }

    case "ADD_ENROLMENT":
      if (
        actions.enrolment_uid !== undefined &&
        actions.face_url !== undefined
      ) {
        let enrolments = [...state.enrolments];
        enrolments.push({
          enrolment_uid: actions.enrolment_uid,
          face_url: actions.face_url,
        });
        return {
          ...state,
          enrolments: enrolments,
        };
      } else {
        return {
          ...state,
        };
      }

    case "DELETE_ENROLMENT":
      if (actions.enrolmentId !== undefined) {
        let enrolments = [...state.enrolments];
        if (enrolments) {
          let index = enrolments.findIndex(
            (x) => x.enrolment_uid === actions.enrolmentId
          );
          if (index > -1) {
            enrolments.splice(index, 1);
          }
          return {
            ...state,
            enrolments: enrolments,
          };
        }
      } else {
        return {
          ...state,
        };
      }

    case "CLEAR_ENROLMENT":
      return {
        ...state,
        enrolments: [],
      };

    case "SAVE_RESULTS":
      if (actions.results !== undefined) {
        return {
          ...state,
          searchResults: actions.results,
        };
      } else {
        return {
          ...state,
          searchResults: undefined,
        };
      }

    case "CLEAR_STATE":
      return {
        ...state,
        enrolments: [],
        user: undefined,
      };

    case "CLEAR_ADMIN":
      return {
        ...state,
        count: undefined,
        people: [],
        updating: 0,
      };

    case "ADMIN_PEOPLE_COUNT":
      return {
        ...state,
        count: actions.count,
      };

    case "ADMIN_LIST_PEOPLE":
      if (actions.people !== undefined && actions.sendTime !== undefined) {
        if (
          actions.sendTime > state.peopleFetchTime ||
          state.peopleFetchTime === undefined
        ) {
          let myPeople = [...state.people];
          for (let i = 0; i < actions.people.length; i++) {
            myPeople.push(actions.people[i]);
          }
          return {
            ...state,
            peopleFetchTime: actions.sendTime,
            people: myPeople,
          };
        }
      }
      return state;

    case "SET_UPDATING":
      if (actions.status !== undefined) {
        let updating = state.updating;
        let adder;
        if (actions.status === true) {
          adder = 1;
        } else {
          adder = -1;
        }
        updating += adder;

        return {
          ...state,
          updating: updating,
        };
      }
      return {
        ...state,
      };

    case "ADMIN_PERSON_APPEND":
      if (actions.person_id !== undefined && actions.face_url !== undefined) {
        let people = [...state.people];
        let index = people.findIndex((x) => x.uid === actions.person_id);
        if (index > -1) {
          let person = { ...people[index] };
          let faces = person.faces ? [...person.faces] : [];
          faces.push(actions.face_url);
          person.faces = faces;
          people[index] = person;

          return {
            ...state,
            people: people,
          };
        }
      }

    default:
      return state;
  }
};

export default databaseReducer;



// WEBPACK FOOTER //
// ./src/global/reducers/databaseReducer.js